import { MedisanteDevice } from '../../../../pages/Device/types';
import { FunctionComponent } from 'react';
import ConfirmationDialog from '../../../../eliot-components/src/ConfirmationDialog/ConfirmationDialog';
import { useResetMeasurementCountMutation } from '../../../../store/api-slice';
import { useConfig } from '../../../../eliot-components/src/ConfigProvider/hooks';
interface Props {
  devices: MedisanteDevice[];
  isOpen: boolean;
  onClose?(): void;
  onCreated(success: boolean, err: string): void;
}
const ResetMeasurementCount: FunctionComponent<Props> = ({
  isOpen,
  onClose,
  devices,
  onCreated,
}) => {
  const config = useConfig();
  const [resetCount, { isLoading }] = useResetMeasurementCountMutation();
  return (
    <div>
      <ConfirmationDialog
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={() => {
          return resetCount({
            apiBaseURL: config.apiBaseURL,
            devices: devices,
          })
            .then(() => {
              onCreated(true, '');
            })
            .catch((err) => {
              onCreated(false, err.message);
            });
        }}
        disabled={isLoading}
        isLoading={isLoading}
        questionText={`Are you sure you want to reset the measurement count?`}
        confirmationText="Confirm"
        cancelText="Cancel"
        title={`Reset measurement count`}
      />
    </div>
  );
};
export default ResetMeasurementCount;
